import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';
import CheckIcon from '@public/icons/Check-3.svg';

export const StyledSimProductSection = styled.section`
  max-width: 1300px;
  margin: 0 auto;
  padding: 3rem 1rem 5rem 1rem;
  font-family: Geomanist, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;

  & h2 {
    font-weight: 500;
    font-size: 32px;
    vertical-align: middle;
    margin-bottom: 1rem;
    color: #0000ff;
    text-align: center;
    @media ${breakpoints.tablet} {
      font-size: 54px;
    }
  }

  & h3 {
    font-family: Roboto;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    margin-bottom: 2.5rem;
  }
`;

export const ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: rgba(124, 146, 213, 0.3) 0 0 26px;
  max-width: 790px;
  margin: 1rem 2rem;
  overflow: hidden;

  @media ${breakpoints.tablet} {
    margin: 2rem 0;
  }
`;

export const ProductHeader = styled.div`
  background: linear-gradient(180deg, #f4111b 0%, #0402fd 72%);
  padding: 3rem 1.5rem;
  color: #fff;

  & h4 {
    font-family: Geomanist, sans-serif;
    font-weight: 700;
    font-size: 28px;
    line-height: 16px;
    text-align: center;
    color: #fff;
    margin: 0;
  }
`;

export const ProductBody = styled.div`
  display: flex;
  flex-direction: column;

  @media ${breakpoints.tablet} {
    flex-direction: row;
  }
`;

export const ProductImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 1.5rem;

  @media ${breakpoints.tablet} {
    width: 40%;
    margin-bottom: 0;
    padding-right: 1.5rem;
  }
`;

export const ProductContent = styled.div`
  padding: 2rem 1rem 2rem 2rem;
  @media ${breakpoints.tablet} {
    width: 60%;
  }
`;

export const ProductDescription = styled.ul`
  margin-bottom: 1.5rem;
  list-style: none;
  padding: 0;
  text-align: left;

  & li {
    font-weight: 200;
    list-style: none;
    padding-left: 2.5rem;
    background: url('${CheckIcon.src}') top left no-repeat;
    margin-bottom: 0.95rem;

    & > b,
    & > strong {
      color: #0402fc;
      font-weight: 400;
    }
  }
`;

export const ContactBoxesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
`;

export const ContactBox = styled.div`
  border: 2px solid #0000ff;
  border-radius: 8px;
  padding: 15px 10px;
  text-align: center;

  @media ${breakpoints.tablet} {
    flex: 1;
    min-width: 200px;
  }

  & h5 {
    font-family: Geomanist, sans-serif;
    font-weight: 500;
    font-size: 17px;
    line-height: 16px;
    color: #0000ff;
    margin-top: 0;
    margin-bottom: 0.5rem;
  }

  & p {
    color: #000000;
    font-family: Geomanist, sans-serif;
    font-weight: 200;
    font-size: 16px;
    line-height: 19px;
    margin: 0;
    & strong {
      font-weight: 700;
    }
  }
`;

export const BottomText = styled.div`
  margin-top: 2rem;
  text-align: center;

  & p {
    font-family: Roboto, sans-serif;
    font-size: 18px;
    line-height: 28px;
    color: #000;
  }
`;
